import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import CONSTANTS from '../../constants';
import ScrollHelper from '../../helpers/ScrollHelper';
import ViewHelper from '../../helpers/ViewHelper';
import AnalyticsService from '../../services/AnalyticsService';

class Category extends Component {
  // Only render popular category when popularItems are present
  render() {
    let { category, popularItems } = this.props;
    if (category.category_id !== CONSTANTS.MENU.POPULAR_CATEGORY)
      return this.renderCategory(category);
    else if (popularItems && popularItems.length > 0) return this.renderCategory(category);
    return null;
  }

  firebaseEvent(category) {
    let { location } = this.props;
    AnalyticsService.logEvent(CONSTANTS.EVENTS.MENU.CATEGORY, {
      category: CONSTANTS.EVENTS.MENU.GROUP_NAME,
      locationId: location.slug,
      ...category
    });
  }

  redirectToItem = (category) => {
    let { location } = this.props;

    // Helper function to generate Alt Title
    const generateAltKeywords = (category, location) => {
      let altKeywords = category.category_keywords || location.meta.category_keywords || location.meta.appSettings?.category_meta_keywords || `${category.name} by ${location.name}`;
      altKeywords = altKeywords.replace(/\[categoryname\]/g, category.name);
      altKeywords = altKeywords.replace(/\[category\]/g, category.name);
      altKeywords = altKeywords.replace(/\[location\]/g, location.name);
      return altKeywords;
    };

    // Helper function to generate Alt Title
    const generateAltTitle = (category, location) => {
      let altTitle = category.alt_title || location.meta.category_title || location.meta.appSettings?.category_meta_title || `${category.name} by ${location.name}`;
      altTitle = altTitle.replace(/\[categoryname\]/g, category.name);
      altTitle = altTitle.replace(/\[category\]/g, category.name);
      altTitle = altTitle.replace(/\[location\]/g, location.name);
      return altTitle;
    };

    // Helper function to generate Alt Description
    const generateAltDescription = (category, location) => {
      let altDescription = category.description || location.meta.category_description || location.meta.appSettings?.meta_category_description || '';

      if (altDescription) {
        altDescription = altDescription.replace(/\[categoryname\]/g, category.name);
        altDescription = altDescription.replace(/\[category\]/g, category.name);
        altDescription = altDescription.replace(/\[location\]/g, location.name);
        altDescription = altDescription.replace(/\[address\]/g, location.formattedAddress);
        altDescription = altDescription.replace(/\[city\]/g, location.city);
        altDescription = altDescription.replace(/\[cuisinetype\]/g, location.category_name);
      }

      if (!altDescription) {
        altDescription = `Order directly from ${location.name} for delivery, takeaway, curbside pickup or dining in at their restaurant. Support restaurants by ordering directly! | Powered by Plugd`;
      } else {
        altDescription += ' | Powered by Plugd';
      }

      return altDescription;
    };

    // Generate Alt Title and Description
    const alt_title = generateAltTitle(category, location);
    const alt_description = generateAltDescription(category, location);
    const alt_keywords = generateAltKeywords(category, location);


    ViewHelper.setDocumentTitle(alt_title);
    ViewHelper.setDocumentDescription(alt_description);
    ViewHelper.setDocumentKeywords(alt_keywords);
    this.onCategoryClick();
    let category_name = category.name.replace(/ /g, '-');
    ViewHelper.setCanonical(`/${this.props.location.slug}/category/${category_name.toLowerCase()}-${category.category_id}`);
    return this.props.history.push(`/${this.props.location.slug}/category/${category_name.toLowerCase()}-${category.category_id}`);
  };

  onCategoryClick = () => {
    if (
      this.props.location.layout === 'default' ||
      this.props.location.layout === 'small_grid' ||
      this.props.location.layout === 'large_grid'
    ) {
      window.addEventListener('click', (e) => ScrollHelper.scrollTo(e, 'default'));
    } else if (this.props.location.layout === 'old') {
      window.addEventListener('click', (e) => ScrollHelper.scrollTo(e, 'old'));
    }
  };

  renderCategory(category) {
    return (
      <div
        onClick={() => this.redirectToItem(category)}
        className="category f3 highlight-color"
        id={`category-${category.category_id}`}
        key={category.id}
        style={{ color: `${this.props.locationSettings?.basecolor}` }}
      >
        {category.name}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { popularItems, location, locationSettings } = state;
  return { popularItems, location, locationSettings };
}

export default withRouter(connect(mapStateToProps)(Category));
